import { defineMessages } from 'react-intl';

export const pdfViewerWithFieldsMessages = defineMessages({
  previousPageAriaLabel: {
    defaultMessage: 'Previous page',
    id: 'doK4Ge4PPz',
    description: 'Accessibility label for the button that goes to the previous PDF page',
  },
  nextPageAriaLabel: {
    defaultMessage: 'Next page',
    id: 'xB7va6EudN',
    description: 'Accessibility label for the button that goes to the next PDF page',
  },
  zoomOutAriaLabel: {
    defaultMessage: 'Zoom out',
    id: 'degheAl8tA',
    description: 'Accessibility label for the button that decreases PDF zoom',
  },
  zoomInAriaLabel: {
    defaultMessage: 'Zoom in',
    id: 'i4dhBq/kjX',
    description: 'Accessibility label for the button that increases PDF zoom',
  },
});
